import { Component, Input, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { TranslateModule } from "@ngx-translate/core";

export interface MfaFactor {
  tipo: string;
  identificador: string;
}

@Component({
  selector: 'app-select-mfa-factor',
  templateUrl: './select-mfa-factor.component.html',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  styleUrls: ['./select-mfa-factor.component.scss', '../confirm-2FA/confirm-2FA-page.component.scss']
})
export class SelectMfaFactorComponent implements OnDestroy {
  @Input() fatores: MfaFactor[] = [];
  private destroy$ = new Subject<void>();

  constructor(public activeModal: NgbActiveModal) {}

  selectFactor(factor: MfaFactor) {
    this.activeModal.close(factor);
  }

  cancel() {
    this.activeModal.dismiss();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
